/* af1c — homepage grid
 * Clean 3x2 grid of 6 tees. Hover swaps the background color.
 * Same crossfade + grain system as scatter, minus the scatter/swipe logic.
 */

/* ---------- Hover: swap alt background theme ----------
   Two ping-pong layers so switching directly between hover themes
   crossfades cleanly instead of flashing back to the red default. */
const BG_LAYERS = [
  document.getElementById('bg-alt-a'),
  document.getElementById('bg-alt-b'),
];
const BG_THEMES = ['crimson', 'white', 'navy', 'charcoal', 'cream', 'olive'];

// Preload all alt backgrounds so first hover doesn't flash blank.
BG_THEMES.forEach((name) => {
  const pre = new Image();
  pre.src = window.AF1C_BG_URLS[name];
});

// CSS-only gradient themes (no PNG asset). Rendered by setting
// backgroundImage directly to a gradient stack; the animated static-grain
// overlay is drawn by the layer's ::after via a class hook in af1c-product.css.
const CSS_BG_THEMES = {
  'hotgirls-cream':
    'radial-gradient(130% 110% at 80% 105%, rgba(252,246,228,0.9) 0%, rgba(246,238,215,0.6) 22%, rgba(242,232,206,0.28) 45%, rgba(242,232,206,0) 70%),' +
    'radial-gradient(110% 100% at 25% 110%, rgba(150,132,98,0.6) 0%, rgba(176,160,126,0.42) 22%, rgba(200,186,153,0.22) 45%, rgba(214,201,170,0.08) 62%, rgba(214,201,170,0) 78%),' +
    'radial-gradient(160% 120% at 55% -25%, rgba(250,243,222,1) 0%, rgba(240,230,204,0.7) 40%, rgba(232,220,192,0.32) 65%, rgba(232,220,192,0) 90%),' +
    'linear-gradient(165deg, #f1e8d1 0%, #e9dfc8 35%, #ded2b5 65%, #cec09e 100%)',
};

let activeLayer = 0;
let activeTheme = null;

function setHoverBg(theme) {
  if (theme === activeTheme) return;
  activeTheme = theme;
  if (theme) {
    const nextIdx = 1 - activeLayer;
    const nextLayer = BG_LAYERS[nextIdx];
    // CSS-gradient theme: paint the stack directly. Otherwise use the PNG url.
    const cssStack = CSS_BG_THEMES[theme];
    if (cssStack) {
      if (nextLayer.style.backgroundImage !== cssStack) {
        nextLayer.style.backgroundImage = cssStack;
        nextLayer.style.backgroundColor = '#e9dfc8';
      }
    } else {
      const url = `url('${window.AF1C_BG_URLS[theme]}')`;
      if (nextLayer.style.backgroundImage !== url) {
        nextLayer.style.backgroundImage = url;
        nextLayer.style.backgroundColor = '';
      }
    }
    const layerToHide = BG_LAYERS[activeLayer];
    activeLayer = nextIdx;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        nextLayer.style.opacity = '1';
        layerToHide.style.opacity = '0';
        document.body.dataset.hoverBg = theme;
      });
    });
  } else {
    const layerToHide = BG_LAYERS[activeLayer];
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        layerToHide.style.opacity = '0';
        delete document.body.dataset.hoverBg;
      });
    });
  }
}

const gridRoot = document.getElementById('tile-grid');
if (gridRoot) {
  gridRoot.addEventListener('mouseover', (e) => {
    if (window.matchMedia('(hover: none)').matches) return;
    const tile = e.target.closest('.tile');
    if (!tile) return;
    setHoverBg(tile.dataset.bg);
  });
  gridRoot.addEventListener('mouseout', (e) => {
    if (window.matchMedia('(hover: none)').matches) return;
    const tile = e.target.closest('.tile');
    if (!tile) return;
    const related = e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('.tile');
    if (!related) setHoverBg(null);
  });
}

/* Grain overlay moved to af1c-grain.js (loaded globally from theme.liquid). */
